import { AppPagePaths } from "App/routes/paths";

export const REGAL_LIVE_PAGE_DESCRIPTIONS = {
    [AppPagePaths.regalLive]: "Real-time monitoring and management interface.",
} as const;
